import { useDispatch, useSelector } from "react-redux";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { useEffect, useState } from "react";
import { getFormatedDate } from "../../../utils/Functions/table";
import {
  useGetSpinWheelRewardsListDataQuery,
  useUpdateSpinWheelTableHeadDataMutation,
} from "../../../store/queries/Report";
import { subDays } from "rsuite/esm/utils/dateUtils";
import { Button, IconText } from "@wac-ui-dashboard/wac_component_library";

const useSpinWheelRewards = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const dispatch = useDispatch();
  const { showEditModal } = useSelector((state) => state.global);
  const [spinWheelRewardsState, setSpinWheelRewardsState] = useState({
    currentPageSize: 10,
    currentPage: 1,
    search: "",
    startDate: subDays(new Date(), 30),
    endDate: new Date(),
    sortBy: "",
    sortOrder: "desc",
    CardOfferExcelSendModal: false,
    uploadImageModal: false,
    itemId: "",
    showImageModal: false,
    imageData: "",
    tableFeilds: {},
  });
  const {
    data: spinWheelRewardsList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetSpinWheelRewardsListDataQuery({
    page_size: spinWheelRewardsState?.currentPageSize,
    page: spinWheelRewardsState?.currentPage,
    search: spinWheelRewardsState?.search,
    start_date: spinWheelRewardsState?.startDate
      ? getFormatedDate(spinWheelRewardsState?.startDate)
      : "",
    end_date: spinWheelRewardsState?.endDate
      ? getFormatedDate(spinWheelRewardsState?.endDate)
      : "",
    sort_by: spinWheelRewardsState?.sortBy,
    sort_order: spinWheelRewardsState?.sortOrder,
  });
  useEffect(() => {
    if (spinWheelRewardsList?.fields) {
      let updatedFields = {
        ...spinWheelRewardsList?.fields,
        action: {
          label: "Action",
          sortable: true,
          hidden: false,
          position: 8,
        },
      };
      setSpinWheelRewardsState((prev) => ({
        ...prev,
        tableFeilds: updatedFields,
      }));
    }
    // eslint-disable-next-line
  }, [spinWheelRewardsList]);
  const [updateSpinWheelTableHeadData] =
    useUpdateSpinWheelTableHeadDataMutation();
  const handleSearch = (e) => {
    setSpinWheelRewardsState((prev) => ({
      ...prev,
      search: e?.target?.value,
      currentPage: 1,
    }));
  };
  const handleClearClick = () => {
    setSpinWheelRewardsState((prev) => ({
      ...prev,
      search: "",
      currentPage: 1,
    }));
  };
  const handleSort = (label) => {
    if (spinWheelRewardsState?.sortBy === label) {
      setSpinWheelRewardsState((prev) => ({
        ...prev,
        currentPage: 1,
        sortOrder: prev.sortOrder === "asc" ? "desc" : "asc",
      }));
    } else {
      setSpinWheelRewardsState((prev) => ({
        ...prev,
        currentPage: 1,
        sortBy: label,
        sortOrder: "asc",
      }));
    }
  };
  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };
  const handleViewImage = (image) => {
    setSpinWheelRewardsState((prev) => ({
      ...prev,
      showImageModal: true,
      imageData: image??"",
    }));
  };
  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data?.[field]}</p>,

      status: (field, data) => (
        <>
          <span className={"pro-badge badge-primary-outline"}>
            {data?.[field]==="REDEEM"? "REDEEMED":data?.[field]}
          </span>
        </>
      ),
      image: (field, data) => (
        <>
          {spinWheelRewardsList?.update_permission && data[field] ? (
            <div className="no-wrap">
              <IconText
                icon={
                  <span className="material-symbols-outlined x4">
                    imagesmode
                  </span>
                }
                title={`${"View Photo"}`}
                onClick={() => handleViewImage(data?.image)}
              />
            </div>
          ) : (
            ""
          )}
        </>
      ),
      action: (field, data) => (
        <>
          {spinWheelRewardsList?.update_permission &&
          data?.status === "AWARD" ? (
            <Button
              onClick={() => {
                setSpinWheelRewardsState((prev) => ({
                  ...prev,
                  uploadImageModal: true,
                  itemId: data?._id,
                }));
              }}
              className={'pro-btn-primary'}
            >
              Redeem
            </Button>
          ) : (
            <p></p>
          )}
        </>
      ),
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };
  const handlePagination = (page) => {
    setSpinWheelRewardsState((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };
  const handlePageSize = ({ value: page_size }) => {
    setSpinWheelRewardsState((prev) => ({
      ...prev,
      currentPageSize: page_size,
      currentPage: 1,
    }));
  };
  const handleUserFeedbackExcelDownload = () => {
    setSpinWheelRewardsState((prev) => ({
      ...prev,
      CardOfferExcelSendModal: !prev.CardOfferExcelSendModal,
    }));
  };
  const handleDateChange = (range) => {
    setSpinWheelRewardsState((prev) => ({
      ...prev,
      currentPage: 1,
      startDate: new Date(range.startDate),
      endDate: new Date(range.endDate),
    }));
  };
  const handleDateRangeChange = (range) => {
    const startDate = range[0];
    const endDate = range[1];

    setSpinWheelRewardsState((prev) => ({
      ...prev,
      currentPage: 1,
      startDate: new Date(startDate),
      endDate: new Date(endDate),
    }));
  };
  const closeImageModal = () => {
    setSpinWheelRewardsState((prev) => ({
      ...prev,
      imageData: "",
      showImageModal: false,
    }));
  };
  return {
    isLoading,
    isFetching,
    showEditModal,
    paginationOptions,
    spinWheelRewardsList,
    spinWheelRewardsState,
    closeImageModal,
    setSpinWheelRewardsState,
    handleUserFeedbackExcelDownload,
    updateSpinWheelTableHeadData,
    handleEditColumnsClick,
    handleDateRangeChange,
    handleDateChange,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  };
};

export default useSpinWheelRewards;
